import FieldDefs from './OutLinksFieldDefs'
import {doLangFields} from '../../lib/ks-tools'
import RequiredHashFilter from '../../mixins/RequiredHashFilter'

export default {
    template: `<div><slot v-bind="self" /></div>`,
    mixins: [RequiredHashFilter],
    data() {
        return {
            // API отчёта не отдаёт данные без условия по статусу
            requiredFilter: 'status=1',
            fields: doLangFields(this, "lang.report.outlinks", FieldDefs),
                sortOrder: [
                {
                    field: 'created_at',
                    direction: 'desc'
            }
            ],
            moreParams: {},
            additionalActions: []
        }
    },
    props: {
        domain: {
            type: String,
            required: true
        }
    },
    computed: {
        getApiUrl() {
            return '/report/simple/links/outlinks?domain=' + this.domain;
        },
        self() {
            return this;
        },
    },
}
